import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@mui/material';

/**
 * Компонент для отображения ошибки валидации
 * @param {Object} props - Пропсы компонента
 * @param {string} props.error - Текст ошибки
 * @param {Object} props.sx - Дополнительные стили
 * @returns {JSX.Element|null} - JSX элемент или null
 */
export const ValidationError = ({ error, sx = { mt: 0.5 } }) => {
  if (!error) return null;
  
  return (
    <FormHelperText error sx={sx}>
      {error}
    </FormHelperText>
  );
};

ValidationError.propTypes = {
  error: PropTypes.string,
  sx: PropTypes.object
};
